/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  NotificationsDispatchPublicControllerResolveShortLinkQueryResponse,
  NotificationsDispatchPublicControllerResolveShortLinkPathParams,
  NotificationsDispatchPublicControllerResolveShortLink404,
} from '../types/NotificationsDispatchPublicControllerResolveShortLink.ts';

function getNotificationsDispatchPublicResolveShortLinkUrl(
  code: NotificationsDispatchPublicControllerResolveShortLinkPathParams['code'],
) {
  const res = { method: 'GET', url: `/api/telegram/notifications/short-links/${code}` as const };
  return res;
}

/**
 * {@link /api/telegram/notifications/short-links/:code}
 */
export async function notificationsDispatchPublicResolveShortLink(
  code: NotificationsDispatchPublicControllerResolveShortLinkPathParams['code'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    NotificationsDispatchPublicControllerResolveShortLinkQueryResponse,
    ResponseErrorConfig<NotificationsDispatchPublicControllerResolveShortLink404>,
    unknown
  >({ method: 'GET', url: getNotificationsDispatchPublicResolveShortLinkUrl(code).url.toString(), ...requestConfig });
  return res.data;
}
